import get from './get'
import update from './update'
import getOne from './get-one'
import create from './create'
import getTaskRecommendations from './get-task-recommendations'

const services = {
  get,
  update,
  getOne,
  create,
  getTaskRecommendations,
}

export default services
